import backend from '../index'

export default async function getBookingRooms() {
  const bookingRooms = await backend.get(`/bookings`)
  return bookingRooms.data
}
